import React, { useState, useEffect } from 'react';
import icon from './images/app_logo.png';
import logo from '../../assets/images/lookmysaloon-removebg-preview.png';

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 60);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''}`} id="navbar">
            <div className="container nav-container">
                <div  className="logo">
                    {/* <img src={icon} alt="Fablikes Logo" style={{height:'50px'}}/> */}
                    <img src={logo} alt="Fablikes Logo" style={{height:'80px'}}/>
                    {/* <span className="logo-text">Fab<span>likes</span></span> */}
                </div>

                <ul className="nav-links desktop-nav mt-3">
                    <li><a href="#home" className="active">Home</a></li>
                    <li><a href="#vendor">Vendor App</a></li>
                    <li><a href="#features">Features</a></li>
                    <li><a href="#dashboard">Profiles</a></li>
                </ul>

                <div className="nav-actions desktop-nav">
                    <a href="#demo" className="btn-primary">Start Free Trial</a>
                </div>

                <button className="mobile-menu-btn" id="mobile-menu-btn" aria-label="Open menu">
                    <i className="fa-solid fa-bars"></i>
                </button>
            </div>
        </nav>
    );
};

export default Navbar;
